import React from "react";
import QRCode from "react-qr-code";
import { useLocation } from "react-router-dom";
import awsConfig from "../aws-config";
import { resolveMenuBaseUrl } from "../utils/menuLinks";

const DEFAULT_MENU_BASE_URL = resolveMenuBaseUrl(awsConfig.menu_base_url);

export default function QRPage() {
  // Get QR data from navigation (HomePage passes link and storeName)
  const location = useLocation();
  const url = location.state?.url || DEFAULT_MENU_BASE_URL;
  const storeName = location.state?.storeName || "Menu";

  // Download QR as PNG
  const handleDownload = () => {
    const svg = document.getElementById("qr-svg");
    if (!svg) return;
    const serializer = new XMLSerializer();
    const svgStr = serializer.serializeToString(svg);
    const canvas = document.createElement("canvas");
    const img = new window.Image();
    img.onload = function () {
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL("image/png");
      const a = document.createElement("a");
      a.href = pngFile;
      a.download = `${storeName}-qr.png`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };
    img.src = "data:image/svg+xml;base64," + window.btoa(svgStr);
  };

  // Print QR
  const handlePrint = () => {
    const printWindow = window.open("", "Print QR", "width=400,height=600");
    printWindow.document.write(`
      <html><head><title>Print QR</title></head><body style='text-align:center;padding:40px;'>
        <h2>${storeName} Menu QR</h2>
        <div>${document.getElementById("qr-svg").outerHTML}</div>
        <p style='font-size:16px;'>${url}</p>
      </body></html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  return (
    <div style={{ padding: 32, maxWidth: 400, margin: "0 auto", textAlign: "center" }}>
      <h2 style={{ marginBottom: 16 }}>{storeName} Menu QR Code</h2>
      <QRCode id="qr-svg" value={url} size={256} style={{ margin: "0 auto" }} />
      <div style={{ marginTop: 16, fontSize: 16, wordBreak: "break-all" }}>{url}</div>
      <div style={{ marginTop: 24, display: "flex", gap: 12, justifyContent: "center" }}>
        <button onClick={handleDownload} style={{ padding: "8px 16px", fontSize: 16 }}>Download QR</button>
        <button onClick={handlePrint} style={{ padding: "8px 16px", fontSize: 16 }}>Print QR</button>
      </div>
      <div style={{ marginTop: 32, color: "#666", fontSize: 14 }}>
        Scan this QR to view or order from your menu.<br />
        You can print and place it on tables, counters, or windows.
      </div>
    </div>
  );
}
